<kui-select [options]="comboValues" (change)="comboChanged($event, true)"> </kui-select>
@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}
